import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListSeries from '../../components/series/list-series.component';
import PAGE_TITLE_LIST from '../../config/page-title.config';

const ContentSeriesView = () => {
  const pageTitle = `${PAGE_TITLE_LIST.CONTENT_SERIES}`;

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListSeries/>
    </AppLayout>
  );
};

export default ContentSeriesView;
